export {
  buscarHistorico,
  buscarStatusProcesso,
  criarPartesBatch,
  finalizarPeticionamento,
  validarCpfCnpjDocumento,
} from './services';
